import { RfiaInvoiceProcessStep } from 'gen/ApiClient';

export const isInvoiceProcessStepOptional = (step: RfiaInvoiceProcessStep) => {
	return step === 'Tender' || step === 'HandoverBeforeApprovals' || step === 'AdvanceInvoice';
};
